export default {
    props: {
        filterableExtra: {
            type: Boolean,
            kComposite: 'filterable.extra'
        }, 
        filterableMessagesAnd: {
            type: String,
            kComposite: 'filterable.messages.and'
        }, 
        filterableMessagesClear: {
            type: String,
            kComposite: 'filterable.messages.clear'
        }, 
        filterableMessagesFilter: {
            type: String,
            kComposite: 'filterable.messages.filter'
        }, 
        filterableMessagesInfo: {
            type: String,
            kComposite: 'filterable.messages.info'
        }, 
        filterableMessagesTitle: {
            type: String,
            kComposite: 'filterable.messages.title'
        }, 
        filterableMessagesIsFalse: {
            type: String,
            kComposite: 'filterable.messages.isFalse'
        }, 
        filterableMessagesIsTrue: {
            type: String,
            kComposite: 'filterable.messages.isTrue'
        }, 
        filterableMessagesOr: {
            type: String,
            kComposite: 'filterable.messages.or'
        }, 
        filterableMessagesSelectValue: {
            type: String,
            kComposite: 'filterable.messages.selectValue'
        }, 
        filterableMessagesCancel: {
            type: String,
            kComposite: 'filterable.messages.cancel'
        }, 
        filterableMessagesOperator: {
            type: String,
            kComposite: 'filterable.messages.operator'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Filterable.js